// mapelements/VOR.js
import React, { useEffect, useState } from "react";

const FIX = ({ map }) => {

  const [isVisible, setIsVisible] = useState(
    localStorage.getItem("fixVisible") === "true"
  );

  const toggleVisibility = () => {
    const newVisibility = !isVisible;
    setIsVisible(newVisibility);
    localStorage.setItem("fixVisible", newVisibility.toString()); // Save state
  };

  // Add or remove the VOR layer
  useEffect(() => {
    if (!map) return;

    const layerId = "points-661xjs";

    const handleMapLoad = () => {
      if (isVisible) {
        map.setLayoutProperty(layerId, "visibility", "visible");
      } else {
        map.setLayoutProperty(layerId, "visibility", "none");
      }
    };

    if (map) {
      handleMapLoad(); 
    } else {
      map.on("load", handleMapLoad);
    }

    // Cleanup on unmount
    return () => {
      if (map) {
        map.setLayoutProperty(layerId, "visibility", "none"); // Hide the layer on unmount
      }
      map.off("load", handleMapLoad);
    };
  }, [map, isVisible]);

  return (
    <button
        data-tooltip-id="map-buttons-tooltip"
        data-tooltip-content="IFR Waypoints"
        className={`w-8 h-8 ${isVisible ? "bg-gray-600" : "bg-gray-400"} text-white flex items-center justify-center`}
        onClick={toggleVisibility}
    >
        <span role="img" aria-label="FIX" className="text-sm">FIX</span>
    </button>
  );
};

export default FIX;